<template>
  <ul class="breadcrumbs flex align-center">
    <li
      v-for="(breadcrumb, index) in breadcrumbs"
      :key="breadcrumb.title"
      :class="clsx('breadcrumbs__item', { 'breadcrumbs__item--last': index === breadcrumbs.length - 1 })"
    >
      <SmartLink
        :url="breadcrumb.path"
        :route="breadcrumb.route"
        :event="breadcrumb.event"
        :method="breadcrumb.method"
        class="breadcrumbs__link"
      >
        {{ breadcrumb.title }}
      </SmartLink>
      <span v-if="index < breadcrumbs.length - 1" class="breadcrumbs__separator">/</span>
    </li>
  </ul>
</template>

<script>
import clsx from 'clsx';
import { SmartLink } from '@/shared/ui/link';

export default {
  props: {
    breadcrumbs: {
      type: Array,
      default: () => [],
    },
  },
  methods: { clsx },
  components: { SmartLink },
};
</script>

<style lang="scss" scoped>
.breadcrumbs {
  margin-bottom: 24px;
  flex-wrap: wrap;
  &__item {
    font-size: 14px;
    font-weight: 400;
    color: #D4D4D8;

    &--last .breadcrumbs__link {
      color: #09090B;
    }
  }

  &__link {
    font-size: 14px;
    font-weight: 400;
    color: #D4D4D8;
  }

  &__separator {
    margin: 0 5px;
    color: #D4D4D8;
  }
}
</style>
